import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { selectFarmManagementProducts } from "../../selectors/selectFarmManagementProducts";
import { selectModalTabId } from "../../selectors/selectModalTabId";
import { GridContainer } from "../generic/grid-layout/GridContainer";
import { IdModal } from "../modals/IdModal";
import { GridItemProducts } from "./GridItemProducts";
var _MasterViewProducts = function (_a) {
    var products = _a.products, onSelect = _a.onSelect, tabId = _a.tabId;
    var _b = useState(0), selectedItemIndex = _b[0], setSelectedItemIndex = _b[1];
    var _c = useState(tabId), selectedTabId = _c[0], setSelectedTabId = _c[1];
    if (tabId !== selectedTabId) {
        setSelectedItemIndex(0);
        setSelectedTabId(tabId);
    }
    var onSelectProduct = function (index) {
        var product = products[index];
        setSelectedItemIndex(index);
        if (onSelect) {
            onSelect(product);
        }
    };
    return (React.createElement("div", { className: "flex h100 w100" },
        React.createElement(GridContainer, { items: products, gridItemRenderer: GridItemProducts, onSelect: onSelectProduct, selectedIndex: selectedItemIndex, key: tabId })));
};
var mapState = function (state) { return ({
    products: selectFarmManagementProducts(state),
    tabId: selectModalTabId(state, IdModal.FarmManagement) || 0,
}); };
export var MasterViewProducts = connect(mapState)(_MasterViewProducts);



//////////////////
// WEBPACK FOOTER
// ./src/features/farm-management/MasterViewProducts.tsx
// module id = 2653
// module chunks = 3